// Module
var code = "<p>资金权限用来规定 谁（账户名或公钥）可以控制本账户资金用于交易及转账。</p> <p>这种设置可以用来方便的构建&lt;多重签名&gt;机制，更多信息请参见 <a href=\"accounts/permissions\">权限</a> 。</p> ";
// Exports
export default code;